import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Box } from './Box'

// TODO add some custom scrollbar!
export const noScrollbarStyles = css`
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`
/**
 * use this component if you can use a Box – if you need the same behavior on some custom component, import noScrollbarStyles instead & use that style snippet
 */
export const NoScrollbarBox = styled(Box)`
  ${noScrollbarStyles}
`
